{
   "actions": {
      "add": "Voeg toe | {name} toevoegen | {name} toegevoegd",
      "add-type": "{type} toevoegen",
      "download": "Downloaden",
      "view": "Bekijken",
      "apply": "Pas toe",
      "bug-report": "Bug rapporteren",
      "cancel": "Annuleer | Annuleren",
      "change": "Aanpassen | {name} aanpassen",
      "change-type": "{type} aanpassen",
      "clear": "Leegmaken",
      "clear-direct-search": "Wis directe zoekopdracht",
      "click-here": "Klik hier",
      "close": "Sluiten",
      "confirm": "Bevestigen",
      "copy": "Kopiëren",
      "create": "{item} aanmaken",
      "delete": "Verwijder | Verwijderen",
      "delete-hard": "Hard verwijderen",
      "export": "Exporteren | {type} exporteren",
      "manage-organisation": "Beheer mijn organisatie",
      "no-batches": "Geen lopende processen",
      "notifications": "Meldingen",
      "notion-page": "Handleiding",
      "refresh": "Pagina herladen",
      "remove": "Wissen | Alles wissen",
      "remove-styling": "Styling verwijderen",
      "reset": "Resetten",
      "reset-filters": "Filters wissen",
      "running-batches": "1 lopend proces | {amount} lopende processen",
      "save": "Opslaan",
      "search": "Zoek | Zoeken",
      "select": "Selecteer",
      "send": "Verstuur",
      "send-request": "Verstuur aanvraag",
      "settings": "Instellingen",
      "show-more": "Toon meer",
      "upload": "Upload | {type} uploaden",
      "print": "Printen",
      "validate": "Valideren",
      "select-all": "Selecteer alles",
      "retry": "Probeer opnieuw",
      "save-and-continue": "Opslaan en volgende",
      "edit": "Pas aan | {name} aangepast"
   },
   "app-name": "NxtMatch",
   "running-processes": {
      "title": "Lopende processen",
      "subtitle": "Werk dat nog je aandacht nodig heeft",
      "tabs": {
         "running": "Lopend",
         "completed": "Voltooid",
         "failed": "Mislukt"
      },
      "bulk-cv-import": "Bulk CV-import",
      "batch-title": "CV-batch {date}",
      "batch-title-with-list": "CV-batch {date} – {name}",
      "uploaded": "{done} van {total} CV's geupload",
      "reviewed": "{done} van {total} CV's gereviewed",
      "duplicates": "{done} van {total} CV's gevalideerd op duplicaten",
      "continue": "Ga verder",
      "cancel": "Annuleren",
      "empty-running": "Geen lopende processen",
      "empty-completed": "Geen voltooide processen",
      "empty-failed": "Geen mislukte processen",
      "just-now": "Zojuist",
      "minutes-ago": "{count} min geleden",
      "hours-ago": "{count} uur geleden",
      "days-ago": "{count} dagen geleden"
   },
   "ai-matching": {
      "ai-matching": "AI Matching",
      "landing-title": "Vind de beste talenten met AI.",
      "landing-subtitle": "Selecteer een vacature en AI analyseert automatisch je talentenpool. Je krijgt een gerankte lijst met uitleg waarom elk talent matcht.",
      "recommended": "Aanbevolen",
      "priority-high": "Hoge prioriteit",
      "feature-smart-match-title": "Slim matchen",
      "feature-smart-match-description": "De criteria worden automatisch uit de vacaturetekst gehaald.",
      "feature-explanation-title": "Uitleg per match",
      "feature-explanation-description": "De AI legt uit waarom iemand wel of niet past.",
      "feature-learns-title": "Leert van jou",
      "feature-learns-description": "Hoe meer je shortlist, hoe beter de suggesties worden.",
      "start-first-matching": "Start je eerste matching",
      "start-matching": "Start matching",
      "ready-to-match": "Vacatures klaar om te matchen",
      "analyse-title": "AI Match Analyse",
      "give-feedback": "Geef feedback",
      "feedback-title": "Geef feedback",
      "feedback-question": "Was deze AI-analyse correct?",
      "feedback-saved": "Feedback opgeslagen",
      "feedback-suggestion-skills": "Skills kloppen",
      "feedback-suggestion-experience": "Goede ervaring",
      "feedback-suggestion-location": "Locatie ok",
      "new-matching": "+ Nieuwe matching",
      "active-matchings": "Actieve matchings",
      "active-matchings-subtitle": "Klik op een vacature om de gevonden talenten te bekijken.",
      "select-a-matching": "<< Selecteer een matching",
      "found-talents": "Gevonden talenten",
      "counts": "{liked} shortlist · {disliked} niet weerhouden",
      "all-talents": "Alle talenten ({count})",
      "shortlist": "Shortlist ({count})",
      "not-selected": "Niet geselecteerd ({count})",
      "matching-in-progress": "AI matching is bezig...",
      "select-a-candidate": "Selecteer een kandidaat",
      "no-preference": "Geen voorkeur",
      "search-radius-from": "Zoekstraal vanaf {city}",
      "keywords": "Keywords",
      "keywords-placeholder": "Bv. winkelbediende, verkoper",
      "keywords-label": "Voeg specifieke skills, technologieën of ervaring toe",
      "delete-matching": "Matching verwijderen",
      "delete-matching-description": "Weet je zeker dat je deze matching wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
      "matching-done": "AI matching is voltooid. De kandidaten zijn beschikbaar."
   },
   "call-lists": {
      "added-to-call-list": "{amount} kandidaat toegevoegd aan de bellijst | {amount} kandidaten toegevoegd aan de bellijst",
      "auto-calling": "Automatisch bellen",
      "call-list": "Bellijst | Bellijsten",
      "call-list-deleted": "Bellijst is verwijderd",
      "candidate-skipped": "Kandidaat {first_name} {last_name} werd overgeslagen omdat deze niet wenst gecontacteerd te worden via telefoon.",
      "candidate-skipped-called": "Kandidaat {first_name} {last_name} werd overgeslagen omdat deze reeds werd gecontacteerd.",
      "candidates": {
         "delete-candidates": "Verwijder kandidaten uit bellijst?",
         "delete-candidates-description": "Deze kandidaten verwijderen. Deze actie kan niet ongedaan gemaakt worden, bent u zeker?",
         "delete-candidates-from-list": "Verwijder kandidaten uit bellijst",
         "set-handled": "Markeer als behandeld",
         "set-unhandled": "Markeer als niet behandeld"
      },
      "delete-call-list": "Verwijder bellijst?",
      "delete-call-list-description": "De bellijst {call_list} verwijderen. Deze actie kan niet ongedaan gemaakt worden, bent u zeker?",
      "failed-lookups": "{amount} waarden konden niet gevonden worden.",
      "import-candidates-call-list": "Importeer kandidaten in bellijst",
      "my-call-lists": "Mijn bellijsten",
      "no-candidates-added-to-call-list": "Er werden geen kandidaten toegevoegd aan een bellijst!",
      "no-new-candidates-added-to-call-list": "Geen nieuwe kandidaten toegevoegd aan bellijst",
      "put-in-values": "Geef je waarden in (gescheiden door 'enter')",
      "saved-call-list": "Opgeslagen bellijsten",
      "zoiper-message": "Vergeet niet om in de settings van Zoiper de optie 'Enable incoming call handling' aan te zetten en deze na het bellen terug af te zetten."
   },
   "candidates": {
      "view-candidate": "Bekijk kandidaat",
      "able-bodied-person": "Valide",
      "account-number": "Rekeningnummer",
      "activated-message": " De kandidaat activeerde zijn account en beheert vanaf nu zijn persoonlijke gegevens zelf. Als er gegevens ontbreken, gebruik dan de <span style=\"color: var(--nxt-main)\"><i class=\"fa-solid fa-paper-plane\"></i> Verifieer</span> knoppen bij de ontbrekende gegevens zodat de kandidaat de ontbrekende gegevens kan aanvullen.",
      "activated-title": "Kandidaat beheert zijn eigen data",
      "add-candidate": "Voeg kandidaat toe",
      "add-candidate-to-pool": "Kandidaat aan pool toevoegen | Kandidaten aan pool toevoegen",
      "add-to-pool": "Toevoegen aan NxtPlan pool",
      "added-to-pool": "Toegevoegd aan de NxtPlan pool",
      "approval-history": "Goedkeuringhistoriek",
      "approval-state": "Goedkeuringstatus",
      "ask-for-approval-success": "Goedkeuringverzoek is verzonden",
      "bic-number": "Bic-nummer",
      "birth-date": "Geboortedatum",
      "board": "Board",
      "bulk-parse-cv": "CV's in bulk parsen",
      "bulk-parse-resume": "CV's in bulk parsen",
      "candidate": "Kandidaat | Kandidaten",
      "candidate-created": "Kandidaat is toegevoegd",
      "candidate-in-running-selected-customers": "De kandidaat is reeds in de running voor een van de geselecteerde firma's",
      "candidate-poked": "De kandidaat werd gepoked",
      "candidate-updated": "Kandidaat is gewijzigd",
      "certificates": "Attest | Attesten",
      "citizen-service-number": "Burgerservicenummer",
      "click-to-go-to-candidate": "Klik hier om naar de kandidaat te gaan",
      "communication-preferences": "Hoe wens je communicatie omtrent {type} te ontvangen?",
      "competences": "Competentie | Competenties",
      "contract-type": "Contract type",
      "courses": "Cursus | Cursussen",
      "current-data": "Huidige gegevens",
      "curriculum-vitae": "Curriculum vitae | CV",
      "define-candidate-and-cv": "Definieer kandidaat en CV",
      "define-candidate-and-resume": "Definieer kandidaat en resume",
      "degree": "Diploma | Diploma's",
      "degree-level": "Opleidingsniveau",
      "delete-candidates": "Kandidaat verwijderen | Kandidaten verwijderen",
      "delete-note": "Verwijder notitie",
      "delete-note-description": "Ben je zeker dat je deze notitie wenst te verwijderen?",
      "delete-resume": "CV verwijderen",
      "dependant": "Personen ten laste",
      "desired-function": "Gewenste functies",
      "disabled-person": "Mindervalide",
      "download-file": "Bestand downloaden",
      "download-resume": "Resume downloaden",
      "drivers-license": "Rijbewijs",
      "edit-candidate": "Pas kandidaat aan",
      "educations": "Studie | Studies",
      "email": "Emailadres",
      "experience": "Ervaring | Ervaringen",
      "export-limit-exceeded": "Niet mogelijk om meer dan {amount} resultaten te exporteren",
      "exporting-candidates": "Kandidaten aan het exporteren",
      "first-name": "Voornaam",
      "found-existing-candidate-with-social-security-number": "Er werd een bestaande kandidaat gevonden met dit rijksregisternummer.",
      "free-edit-text": "Mail naar kandidaat",
      "free-text-mail": "Vrije tekst",
      "frontier-worker-certificate": "Attest grensarbeider",
      "internal-employee": "Interne werknemer",
      "invalid-bsn-number": "Burgerservice nummer is ongeldig!",
      "invalid-emails": "{amount} kandida(a)t(en) hebben geen email en werden niet toegevoegd!",
      "invalid-french-SSN": "Rijksregisternummer is ongeldig",
      "job-content": "Job-inhoud",
      "job-function": "Functie",
      "job-preferences": "Jobvoorkeuren",
      "journey": "Journey",
      "journey-to-candidate": "Journey mailen naar kandidaat",
      "journeys": "Journeys",
      "journey-dropdown-info-text": "Journeys op status \"ongoing\" kunnen verstuurd worden.",
      "language-knowledge": "Taalkennis | Taalkennis",
      "language-knowlegde": "Taalkennis",
      "last-active": "Laatst actief",
      "last-contact": "Laatste contact",
      "last-name": "Naam",
      "mail-candidates": "Kandidaat mailen | Kandidaten mailen",
      "mail-to-team": "Presenteer kandidaat aan team",
      "major": "Studierichting",
      "marital-status": "Burgerlijke staat",
      "max-amount-candidates": "Maximum {amount} kandidaat | Maxiumum {amount} kandidaten",
      "national-registration-number": "Rijksregisternummer",
      "nationality": "Nationaliteit",
      "no-activities": "Geen activiteiten gevonden",
      "no-approval-state": "Geen goedkeuringstatus",
      "no-email": "{name} heeft geen e-mailadres",
      "no-email-contact-allowed": "Kandidaat wenst niet via email gecontacteerd te worden | Een of meerdere kandidaten wensen niet via email gecontacteerd te worden",
      "no-journeys": "Geen journeys gevonden",
      "no-phone-contact-allowed": "Kandidaat wenst telefonisch niet gecontacteerd te worden",
      "no-sms-contact-allowed": "Kandidaat wenst niet via sms gecontacteerd te worden",
      "no-whatsapp-contact-allowed": "Kandidaat wenst niet gecontacteerd te worden via WhatsApp",
      "note-deleted": "Notitie verwijderd!",
      "note-info": "Notities worden opgeslagen onder de activiteiten-tab in het detail van de kandidaat. Je kan deze nadien nog wijzigen of verwijderen.",
      "nxtform-journey": "NxtForm Journey",
      "official-address": "Officieel adres",
      "on-pension": "Met pensioen?",
      "open-resume": "Open CV",
      "open-video-call": "Neem deel aan een videocallvergadering",
      "parse-cv": "CV parsen | CV's parsen",
      "parse-resume": "CV parsen | CV's parsen",
      "parsed-data": "Gegevens uit geparset document",
      "partner-info": "Partnergegevens | Partner-gegevens",
      "partner-salary": "Partner salaris",
      "payment-details": "Betalingsdetails | Betaal-gegevens",
      "pension": "Pensioen",
      "phase": "Fase",
      "poke": "Poke | Poked",
      "poke-candidate": "Poke kandidaat",
      "pool": "Pool | Pools",
      "pools-candidate-has-been-deleted-from": "Pools waaruit de kandidaat werd verwijderd",
      "position-name": "De naam van de vacature",
      "preferences": "Voorkeur | Voorkeuren",
      "preferred-functions": "Gewenste functies",
      "preferred-job-type": "Gewenst functietype",
      "preferred-job-types": "Gewenste jobsoort(en)",
      "profession": "Beroep",
      "profile-picture": "Profielfoto",
      "propose-candidate": "Kandidaat voorstellen",
      "referral-code": "Referral code",
      "regions": "Werkregio | Werkregio's",
      "reset-poked": "Reset poke",
      "residential-address": "Verblijfsadres",
      "resume": "CV",
      "retired-since": "Op pensioen sinds",
      "school": "School",
      "searched-functions": "Gezochte functies",
      "select-customer": "Selecteer firma's",
      "send-form": "NxtForm Journey versturen",
      "show-candidate-details": "Toon details van de kandidaat",
      "social-security-number": "Rijksregisternummer | Belgisch RRNR",
      "statute": "Statuut",
      "tax-certificate": "Belastingcertificaat",
      "work-schedules": "Tijdsregeling",
      "transport-methods": "Vervoer",
      "upload-curriculum-vitae": "Upload een CV",
      "upload-id-card": "Identiteitskaart uploaden",
      "upload-profile-picture": "Upload profielfoto",
      "valid-from": "Geldig vanaf",
      "valid-till": "Geldig tot",
      "verify": "Informatie opvragen bij de kandidaat.\n\nDe kandidaat ziet dit als een taak in de app.",
      "verify-description": "U wilt de gegevens van de kandidaat verifiëren.\n\n Hierdoor wordt er in de app van de kandidaat een taak aangemaakt waarin de gegevens kunnen worden aangevuld/geverifieerd.",
      "verify-title": "Gegevens verifiëren",
      "voluntary-amount": "Vrijwillig bedrag",
      "voluntary-percentage": "Vrijwillig percentage",
      "withholding-tax": "Bedrijfsvoorheffing | Bedrijfs-voorheffing",
      "work-experience": "Ervaringen",
      "work-experience-types": "Type",
      "references": "Referentie | Referenties",
      "add-to-pay": "Toevoegen als NxtPay werknemer",
      "eid": "eID",
      "drag-eid-here": "Sleep de eID in dit vak",
      "eid-has-been-loaded": "eID data werd overgenomen",
      "view-working-documents": "Bekijk werkdocumenten",
      "identity-documents": "Identiteitsdocumenten",
      "sex": "Geslacht",
      "identity-card-front": "Voorkant identiteitskaart",
      "identity-card-back": "Achterkant Identiteitskaart",
      "work-permit": "Werkvergunning",
      "birth-place": "Geboorteplaats",
      "bulk-parse-resume-warning": "Er kunnen maximaal 20 bestanden per keer verwerkt worden.",
      "slots": "Slots",
      "person": "Person",
      "employee": "Employee",
      "resume-upload": {
         "title": "CV's in bulk parsen V2",
         "subtitle": "Upload hier meerdere CV's. Je hoeft niet te wachten tot alle CV's zijn geüpload om te beginnen reviewen.",
         "subtitles": {
            "load": "Upload hier meerdere CV's. Je hoeft niet te wachten tot alle CV's zijn geüpload om te beginnen reviewen.",
            "review": "Review hier de geüploade CV's op ontbrekende data of valideer op gelijkaardige kandidaten.",
            "validate": "Mogelijk bestaand talent gevonden. Selecteer de juiste match of maak een nieuwe talent aan.",
            "confirm": "Bepaal welk talent je wil opslaan en/of aan een bellijst wil toevoegen."
         },
         "go-to": "Ga naar",
         "upload-placeholder": "Sleep & laat los of blader door bestanden",
         "supported-formats": "Ondersteunde formaten: PDF, DOC, DOCX, ODT, JPG, PNG",
         "save-and-close": "Bewaar & sluit (ga later verder)",
         "review-cvs": "Review CV's",
         "confirm-import": "Kandidaten importeren",
         "confirm-talents": "Bevestig {count} talent | Bevestig {count} talenten",
         "confirm-success": "{created} nieuwe en {updated} bijgewerkte kandidaten geïmporteerd",
         "confirm-counts": "{new} nieuw - {updated} bijgewerkt",
         "selected-count": "{count} geselecteerd",
         "review-progress": "{done}/{total} gereviewed",
         "validate-progress": "{done}/{total} gevalideerd",
         "mark-as-reviewed": "Markeer als gereviewed",
         "mark-as-to-review": "Markeren als te reviewen",
         "confirm-and-next": "Bevestig en volgende",
         "bulk-review-success": "{count} CV gemarkeerd als gereviewed | {count} CV's gemarkeerd als gereviewed",
         "bulk-review-failed": "{count} CV vereist aandacht | {count} CV's vereisen aandacht",
         "no-docs-to-review": "Nog geen verwerkte CV's om te reviewen.",
         "no-duplicates": "Geen duplicaten te valideren.",
         "select-cvs": "Selecteer CV's",
         "select-doc": "Selecteer een CV in de lijst.",
         "preview-unavailable": "Geen voorbeeld beschikbaar voor dit bestandstype.",
         "refined-detection": "Verfijnde detectie",
         "refined-detection-link": "Ga naar verfijnde detectie >",
         "refined-detection-done": "Klaar met verfijnen",
         "refined-detection-unavailable": "Verfijnde detectie is niet beschikbaar voor dit CV.",
         "found-in-cv": "Gevonden in CV",
         "found-in-nxtpeople": "Gevonden in NxtPeople",
         "new-talent": "Nieuw talent",
         "pending-docs-warning": "{count} CV vereist nog een actie voor je kan importeren | {count} CV's vereisen nog een actie voor je kan importeren",
         "processing-docs-warning": "Sommige CV's worden nog verwerkt. Wacht tot ze klaar zijn voor je importeert.",
         "link-source": "Koppel bron aan talent",
         "save-in-call-list": "Bewaar talent in bellijst",
         "no-call-list-title": "Geen bellijst geselecteerd",
         "no-call-list-warning": "Je hebt geen bellijst geselecteerd. De kandidaten worden toegevoegd aan de standaard kandidatenlijst.",
         "import-anyway": "Importeer zonder bellijst",
         "doc-status": {
            "to-review": "Te reviewen",
            "reviewed": "Gereviewed",
            "validate-duplicate": "Valideer duplicaat",
            "validated": "Gevalideerd",
            "completed": "Voltooid"
         },
         "tabs": {
            "load": "Laad CV's op",
            "review": "Review CV's",
            "validate": "Valideer op duplicaten",
            "confirm": "Bevestig"
         },
         "max-files-warning": "Er kunnen maximaal {max} bestanden per keer verwerkt worden.",
         "files-rejected": "{count} bestand(en) overgeslagen (niet-ondersteund type of te groot).",
         "upload-failed": "Uploaden mislukt",
         "batch-failed": "Kon het uploaden niet starten",
         "status": {
            "pending": "In afwachting",
            "uploading": "Bezig met uploaden..",
            "processing": "Bezig met verwerken..",
            "done": "Klaar",
            "failed": "Mislukt"
         }
      }
   },
   "communication": {
      "unread-filter": "Toon alleen ongelezen berichten"
   },
   "communications": {
      "actions": {
         "scroll-to-load-messages": "Scroll om berichten in te laden"
      },
      "all-channels": "Alle kanalen",
      "all-directions": "Alle richtingen",
      "all-teams": "Alle teams",
      "change-team": "Team wijzigen",
      "channel": "Kanaal",
      "communication": "Communicatie | Communicaties",
      "conversation": "Bericht | Berichten",
      "direction": "Richting",
      "end-of-messages": "Einde van berichten",
      "go-to-mail-conversations": "Ga naar email conversatie met {name}",
      "go-to-message-conversations": "Ga naar sms/WhatsApp conversatie met {name}",
      "incoming": "Inkomend",
      "linked-customer": "Gekoppelde firma",
      "linked-position": "Gekoppelde vacature",
      "mark-as-read": "Markeer als gelezen",
      "mark-as-unread": "Markeer als ongelezen",
      "outgoing": "Uitgaand",
      "receiver": "Ontvanger",
      "search-for-candidate": "Zoeken naar kandidaat",
      "search-for-customer": "Zoeken naar firma",
      "search-on-email": "Zoeken op email",
      "search-on-phonenumber": "Zoeken op telefoonnummer",
      "sender": "Verzender",
      "show-most-recent-message": "Toon recentste bericht",
      "type-a-message": "Type een bericht",
      "24-hours-after-last-send-message": "Er is meer dan 24u verlopen sinds het laatste inkomende bericht.",
      "click-to-send-as-sms": "Klik hier om als een sms te versturen.",
      "communication-has-been-send-as-type": "Je bericht werd verstuurd als {type}!",
      "recipients": "Ontvanger | Ontvangers",
      "bind_number": "Communicatie koppelen",
      "bind-number-modal": {
         "title": "Communicatie koppelen aan {type}"
      },
      "no-type-found": "Geen {type} gevonden voor telefoonnummer!",
      "want-to-create-a-new-type": "Zou u een nieuwe {type} willen aanmaken?",
      "sms-character-limit": "SMS Character Limit: {limit} tekens"
   },
   "customer": {
      "no-company-results": "Er zijn geen resultaten gevonden. Geef een ondernemingsnummer of naam in om deze te importeren!",
      "import-company": "Importeren",
      "note-info": "Notities worden opgeslagen onder de activiteiten-tab in het detail van de firma. Je kan deze nadien nog wijzigen of verwijderen."
   },
   "customers": {
      "activity": "Activiteit | Activiteiten",
      "add-activity": "Voeg activiteit toe",
      "add-customer": "Voeg firma toe",
      "address-deleted": "Adres werd verwijderd!",
      "addresses": "Tewerkstellingsadres | Tewerkstellingsadressen",
      "branch-amount": "Aantal vestigingen",
      "click-to-go-to-customer": "Klik hier om naar de firma te gaan.",
      "closing-date": "Afsluitdatum",
      "commercial-name": "Commerciële naam",
      "company-data": "Bedrijfsgegevens",
      "company-number": "Bedrijfsnummer",
      "contact-added": "Contact toegevoegd",
      "contact-deleted": "Contactpersoon is verwijderd!",
      "contacts": "Contactpersoon | Contactpersonen | Contact-personen",
      "customer": "Firma | Firma's",
      "customer-address": "Firma-adres",
      "customer-created": "Firma werd toegevoegd",
      "customer-data": "Klantgegevens",
      "customer-name": "Firmanaam",
      "customer-updated": "Firma werd gewijzigd",
      "creditworthiness-warning": "Let op: Deze klant heeft een negatieve kredietwaardigheidsstatus ({credit_worthy_status_name}).",
      "delete-customers": "Firma verwijderen | Firma's verwijderen",
      "dutch-company-number": "KVK-nummer",
      "dutch-vat-number": "KVK-nummer",
      "edit-customer": "Pas firma aan",
      "email-missing": "E-mail ontbreekt",
      "employee-amount": "Aantal werknemers",
      "employment-address": "Tewerkstellingsadres",
      "employment-region": "Tewerkstellingsregio",
      "founded-at": "Oprichtingsdatum",
      "free-edit-text": "Mail naar firma",
      "french-company-number": "Sirene nummer",
      "french-vat-number": "Siren-nummer",
      "interim-amount": "Aantal uitzendkrachten",
      "legal-form": "Rechtsvorm",
      "mail-customers": "Firma mailen | Firma's mailen",
      "max-amount-customers": "Maximum {amount} firma's",
      "nace-code": "NACE-Code",
      "name": "Naam",
      "official-name": "Officièle naam",
      "phone-number-missing": "Telefoonnummer ontbreekt",
      "primary-address": "Maatschappelijke zetel | Maatschappelijke zetel",
      "sector": "Sector",
      "select-contact-person": "Selecteer contactpersoon",
      "spontaneous-application-not-allowed": "Spontaan voorstellen aan deze firma is niet toegelaten.",
      "spontaneous-application-team-only": "Spontaan voorstellen aan deze firma is enkel toegelaten voor team {team}.",
      "spontaneous-application-access": "Spontane voorstelling",
      "vat-number": "Ondernemingsnummer",
      "vat-number-error": "Ongeldig {item}!"
   },
   "follow-up": {
      "add-new-status": "Nieuwe status toevoegen",
      "assign-to": "Toewijzen aan",
      "assigned-by": "Toegewezen door",
      "assigned-to": "Toegewezen aan",
      "by": "Tegen",
      "change-hit": "Match aanpassen",
      "change-status": "Status corrigeren",
      "click-here-to-view-match": "Klik hier om match te openen",
      "completed": "voltooid",
      "create-task": "Maak een taak aan",
      "created-by": "Aangemaakt door",
      "delete-hits-description": "Weet je zeker dat je deze match wilt verwijderen? | Weet je zeker dat je deze matches wilt verwijderen?",
      "delete-match": "Match verwijderen | Matches verwijderen",
      "description": "Omschrijving",
      "expired-at": "Vervalt op",
      "follow-up": "Opvolging | Opvolgingen",
      "form-follow-up": "NxtForm-opvolging",
      "general": "Algemeen",
      "go-to-matching": "Start Matching!",
      "spontaneous-application-not-allowed": "Spontaan voorstellen aan deze firma is niet toegelaten.",
      "hit": "Match | Matches",
      "hit-changed": "Match is aangepast",
      "hit-closed": "Match afsluiten | Matches afsluiten",
      "hit-created": "Match aangemaakt | Matches aangemaakt",
      "hit-deleted": "Match verwijderd | Matches verwijderd",
      "hit-filled": "Match ingevuld",
      "hit-status-added": "Match status toegevoegd",
      "hit-status-changed": "Match status gewijzigd | \nMatches statussen gewijzigd",
      "hits-afsluiten": "Matches afsluiten",
      "mark-as-completed": "Markeer als voltooid",
      "mark-as-incomplete": "Markeer als onvoltooid",
      "new-status": "Volgende status toevoegen",
      "select-application": "Selecteer applicatie",
      "show-completed-tasks": "Toon voltooide taken",
      "subject": "Onderwerp",
      "task-type": "Taaktype",
      "tasks": "Taak | Taken",
      "subject-type": "Type onderwerp",
      "create-hit": "Maak een match aan",
      "edit-task": "Taak aanpassen",
      "assign-user": "Gebruiker toewijzen aan match",
      "attendance": "Aanwezigheid"
   },
   "general": {
      "no-mails-possible": "Geen mails mogelijk voor de geselecteerde waarden",
      "contact-person": "Contactpersoon"
   },
   "generic": {
      "access-denied": "Toegang geweigerd",
      "account": "Account",
      "action-cant-be-undone": "Deze actie kan niet ongedaan gemaakt worden, ben je zeker?",
      "actions": "Acties",
      "active": "Actief",
      "add-contact": "Contact toevoegen",
      "add-phone-number": "Voeg telefoonnummer toe",
      "add-to-call-list": "Voeg toe aan bellijst",
      "addresses": {
         "add-address": "Voeg adres toe",
         "add-employment-address": "Tewerkstellingsadres toevoegen",
         "address": "Adres",
         "address-added": "Adres werd toegevoegd",
         "address-updated": "Adres werd aangepast",
         "box": "Bus",
         "city": "Stad",
         "country": "Land",
         "number": "Nummer",
         "postal-code": "postcode",
         "street": "Straat",
         "update-address": "Tewerkstellingsadres aanpassen",
         "use-location": "Gebruik locatie om betere resultaten te krijgen"
      },
      "again": "Opnieuw",
      "all": "Alles | Alle",
      "alternative-labels": "Alternatieve labels",
      "anonymous": "Anoniem",
      "answer": "Antwoord",
      "app-update-status": "Cool new features on the way... Daarom kan er downtime optreden op donderdag tussen 18u en middernacht. Bedankt voor je geduld tijdens het onderhoud. Check de nieuwe functies later!",
      "application": "Sollicitatie",
      "appointment-created": "Afspraak <b>{type}</b> met <b>{name}</b> op <b>{date}</b> is ingepland.",
      "back-to-home-screen": "Naar startscherm",
      "based-on-adres": "op basis van adres",
      "body": "Inhoud",
      "call": "Bellen",
      "call-later": "Later terugbellen",
      "call-registerd": "Bellen is geregistreerd",
      "can-edit": "Kan aanpassen",
      "change-callList": "Bellijst wijzigen",
      "change-filters": "Bewerk zoekopdracht",
      "direct-search-priority-info": "Je filters blijven behouden tijdens een directe zoekopdracht.",
      "characters-left": "{count} karakters over",
      "choose-year": "Geef een specifiek jaar in",
      "clear": "Leegmaken",
      "clear-cache": "Cache wissen",
      "cache-cleared": "Cache gewist",
      "click-here-to-view-the-message": "Klik hier om het bericht te bekijken",
      "comment": "Opmerking",
      "communication": "Communicatie | Communi-catie",
      "communication-created": "Communicatie is geregistreerd",
      "communication-language": "Communicatietaal",
      "communication-via": "Communicatie via",
      "confirm-remove-filter": "Zoekopdracht {name} verwijderen. Deze actie kan niet ongedaan gemaakt worden, bent u zeker?",
      "confirmation-text": "Bevestigingstekst",
      "contact": "Contact",
      "contact-added": "Contactpersoon werd toegevoegd",
      "contact-data": "Contactgegevens | Contact-gegevens",
      "contact-updated": "Contactpersoon is bijgewerkt",
      "content": "Inhoud",
      "continue-editing": "Verdergaan met bewerken",
      "continue-editing-form": "Vul formulier verder aan",
      "copied-to-clipboard": "{type} gekopieerd!",
      "created-at": "Gemaakt op",
      "customer": "Klant | Klanten",
      "dates": {
         "date": "Datum",
         "day": "Dag | Dagen | d",
         "days": {
            "friday": "Vr | Vrijdag",
            "monday": "Ma | Maandag",
            "saturday": "Za | Zaterdag",
            "sunday": "Zo | Zonddag",
            "thursday": "Do | Donderdag",
            "tuesday": "Di | Dinsdag",
            "wednesday": "Wo | Woensdag"
         },
         "end-date": "Einddatum",
         "from": "Van",
         "hour": "Uur | Uren | u",
         "month": "Maand | Maanden | m",
         "present": "Heden",
         "start-date": "Startdatum",
         "till": "Tot",
         "week": "Week | Weken | w",
         "year": "Jaar | Jaar | j"
      },
      "delete": "{name} is verwijderd!",
      "delete-file": "Ben je zeker dat je dit {fileType} wil verwijderen?",
      "delete-resume": "CV verwijderen",
      "deleted-successfully": "{type} is verwijderd!",
      "description": "Omschrijving",
      "deselect-all": "Alles deselecteren",
      "diff": "Periode van dienstverband",
      "direct-search": "Rechtstreeks zoeken",
      "document": "Bestand | Bestanden",
      "document-type": "Type document",
      "documents": "Document | Documenten",
      "dont-save": "Niet opslaan",
      "drag-file-to-upload": "Sleep bestand om te uploaden",
      "drop-file-here": "Drop je bestand(en) hier!",
      "duration": "Periode",
      "edit": "Aanpassen | {name} aangepast!",
      "edit-call-list": "Pas bellijst aan",
      "edit-filters": "Pas zoekopdracht aan",
      "email": "Email",
      "event": "Gebeurtenis",
      "email-send-success": "Email(s) zijn verstuurd.",
      "employer": "Werkgever",
      "end": "Einde",
      "erase-filters": "Filters wissen",
      "reset-filters": "Filters resetten",
      "expire-date": "Vervaldatum",
      "expires-in": "Verloopt in",
      "expires-on": "Verloopt op:",
      "fax": "Fax",
      "feedback": {
         "candidate-selection": "Vul een firma (en optioneel vacature) in om de voorstellingsopties weer te geven in de contactflow.",
         "communication-preference-warning-description": "Deze kandidaat wenst niet gecontacteerd te worden via telefoon, ben je zeker dat je wil bellen?",
         "communication-saved": "Communicatie afgewerkt",
         "customer-selection": "Vul een kandidaat (en optioneel vacature) in om de voorstellingsopties weer te geven in de contactflow.",
         "date-cannot-be-after": "Datum kan niet na {date} zijn!",
         "date-cannot-be-before": "Datum kan niet voor {date} zijn!",
         "down-for-maintenance": "Sorry, we zijn momenteel niet bereikbaar voor gepland onderhoud!",
         "duplicate-file": "Duplicaat bestand",
         "error": "Er ging iets mis!",
         "failed-sms": "{amount} SMS'en konden niet worden verzonden.",
         "failed-whatsapp": "{amount} WhatsApp bericht kon niet worden verzonden. | {amount} WhatsApp berichten konden niet worden verzonden.",
         "file-too-large": "Het bestand dat u probeert te uploaden is te groot!",
         "invalid-email": "Dit is geen geldig e-mailadres",
         "invalid-url": "Dit is geen geldige url",
         "invited-for-videocall": "Uitnodiging voor videobellen is verstuurd",
         "is_qualified": "Komt in aanmerking",
         "loading": "Laden...",
         "max-filesize": "De maximaal toegelaten bestandsgrootte is {amount}{sizeType}.",
         "max-length": "De maximum lengte is {value}",
         "max-options": "Maximum {amount} {type}",
         "max-value": "De maximum waarde is {value}",
         "min-length": "De minimum lengte is {value}",
         "min-value": "De minimum waarde is {value}",
         "no-access": "Geen toegang tot de opgevraagde data",
         "no-recipient-with-permission": "Ontvanger wenst niet gecontacteerd te worden via {methode}.",
         "no-results": "Geen resultaat | Geen resultaten",
         "no-valid-language": "Selecteer een geldige taal",
         "no-valid-recipient": "Selecteer een geldige ontvanger",
         "no-valid-recipients": "Ontvangers willen niet gecontacteerd worden via {methode}.",
         "no-valid-template": "Template: \"<strong>{templateKey}</strong>\" kon niet gevonden worden. Controleer de template instellingen in Mandrill.",
         "no-valid-template-translation": "Template bestaat niet in deze taal ({lang})!",
         "not-qualified": "Komt niet in aanmerking",
         "position-selection": "Vul een kandidaat in om de voorstellingsopties weer te geven in de contactflow.",
         "refresh-to-update": "Er is een update beschikbaar. Refresh de pagina om de update te installeren.",
         "required": "Dit veld is verplicht",
         "service-unavailable": "Service onbeschikbaar!",
         "start-typing-to-search": "Begin met typen om te zoeken...",
         "sucessful-change-communication": "{amount} communicatie berichten werden aangepast",
         "sucessful-sms": "Sms('en) zijn verzonden.",
         "sucessful-whatsapp": "WhatsApp berichten verzonden",
         "unsaved-changes": "Wijzigingen niet opslaan?",
         "unsaved-changes-description": "Als je op “verwijderen” klikt, gaan alle gemaakte wijzigingen verloren. Klik op “annuleren” om door te gaan met bewerken",
         "update-available": "Er is een update beschikbaar.",
         "whatsapp-sent": "WhatsApp bericht verzonden",
         "contact-support": "Gelieve contact op te nemen met onze support dienst als het probleem zich blijft voordoen",
         "not-allowed": "Je hebt geen toegang tot de opgevraagde data",
         "not-found": "We konden de opgevraagde data niet vinden.",
         "validation": "Fout tijdens het valideren van de data",
         "file-type-not-allowed": "File type is niet toegestaan!"
      },
      "file-delete-failed": "Er is iets fout gegaan! Het bestand is niet verwijderd!",
      "file-exists": "Er bestaat al een document van het type {type}. Bij verder gaan zal het document vervangen worden.",
      "file-name": "Bestandsnaam",
      "filter-changed": "Zoekopdracht werd gewijzigd",
      "filter-created": "Zoekopdracht werd toegevoegd",
      "filter-important": "Markeer filter als belangrijk",
      "filter-info": "Combineer trefwoorden met:<br>\n<strong>OR</strong>: één van deze trefwoorden moet in het resultaat voorkomen.<br>\n<strong>AND</strong>: beide trefwoorden moeten in het resultaat voorkomen.<br>\n<strong>NOT</strong>: het trefwoord mag niet in het resultaat voorkomen. vb: NOT master<br>\n<strong>?</strong>: om meerdere schrijfwijzes op te vangen. vb: ele?triciteit<br>\n<strong>\"\"</strong>: bij het zoeken naar de exacte term of 2 woorden samen. vb: \"De Standaard\"<br>",
      "filter-less-important": "Markeer filter als minder belangrijk",
      "filter-removed": "Zoekopdracht werd verwijderd",
      "filters": "Zoekopdracht | Zoekopdrachten",
      "fiscal-data": "Fiscale gegevens",
      "form": {
         "next": "Volgende",
         "previous": "Vorige",
         "select": "Selecteer | Selecteer {type}",
         "missing-data": "Ontbrekende data: vul {properties} aan."
      },
      "free-text": "Vrije tekst",
      "function-category": "Functie categorie",
      "function-data": "Functiegegevens",
      "general": "Algemeen",
      "general-data": "Algemene gegevens",
      "give-call-list-a-name": "Geef je bellijst een naam",
      "give-filter-a-name": "Geef je zoekopdracht een naam",
      "global-videocall-url": "Videocall platform url",
      "global-videocall-url-info": "Geef hier de url in die gebruikers naar het videocall platform brengt. Deze zal gevisualiseerd worden in het contactformulier. De url's voor de verschillende rooms kunnen per team ingesteld worden via de lijst hieronder.",
      "how-do-you-wish-to-mail": "Hoe wilt u mailen?",
      "how-do-you-wish-to-send": "Hoe wil je versturen?",
      "id": "Id",
      "id-card": "Identiteitskaart",
      "identity": "Identiteit",
      "important": "Belangrijk",
      "inactive": "Inactief",
      "in-office": "Op kantoor",
      "include_job_distances": "Inclusief werkregio",
      "included": "Inbegrepen | {type} inbegrepen",
      "incoming-call-from": "Inkomende oproep van <b>{name}</b>",
      "interested": "Interesse",
      "internal-comment-with-appointment": "Interne opmerking bij afspraak",
      "internal-information": "Interne informatie",
      "is-graduated": "Geslaagd",
      "job-distances-included": "",
      "all-functions": "Alle functies",
      "job-functions": "Job functie",
      "languages": "Taal | Talen",
      "last-editted": "Laatst aangepast",
      "leave-page": "Ben je zeker dat je de pagina wil verlaten?",
      "leave-page-description": "Bij het verlaten van de pagina zullen alle aanpassing verwijderd worden. Ben je zeker dat je de pagina wil verlaten?",
      "less-important": "Minder belangrijk",
      "loading-items": "{results} van {resultTotal} resultaten worden geladen",
      "location": "Locatie",
      "mail": "E-mail",
      "mail-editors": {
         "mail-candidate-to-customer": "Kandidaat mailen naar firma",
         "mail-candidate-to-team": "Mail kandidaat naar team",
         "mail-positions-to-candidates": "Vacature's mailen naar kandidaten"
      },
      "mail-to": "Mailen aan",
      "match": "Match",
      "max": "Max | Maximum",
      "min": "Min | Minimum",
      "must-meet-all-parameters": "Moet aan alle parameters voldoen.",
      "must-meet-one-parameter": "Moet aan een van de parameters voldoen.",
      "my-contact-data": "Mijn contactgegevens",
      "my-filters": "Mijn zoekopdrachten",
      "name": "Naam | Namen",
      "no": "Nee",
      "no-delete-permission": "Geen rechten om te verwijderen",
      "no-journey-selected": "Selecteer een Journey om door te gaan!",
      "no-results-for-tenant": "Er werden geen {type} gevonden voor deze zoekopdracht!",
      "no-roles-assigned": "Er werden geen {module} rechten toegekend aan je account. Contacteer een administrator om de nodige rechten te verkrijgen.",
      "no-url-provided": "Er is geen URL opgegeven. Sluit het modale venster en probeer het opnieuw!",
      "no-voip-found": "Geen VOIP gevonden voor gebruiker",
      "none": "Geen",
      "not-passed": "Niet geslaagd",
      "note": "Notitie",
      "notification": "Notificatie | Notificaties",
      "off": "Uit",
      "office": "Kantoor",
      "on": "Aan",
      "one": "één",
      "only-this-hit": "Enkel deze match",
      "open-mail-editor": "Mail-editor openen",
      "optional": "Optioneel",
      "organisation": "Organisatie",
      "other": "Ander | Andere",
      "passed": "Geslaagd",
      "per": "Per",
      "personal": "Persoonlijk",
      "phone": "Bel | Bellen",
      "phone-number-invalid": "Ingegeven waarde is geen geldig telefoonnummer!",
      "phone-number-invalid-country": "Geselecteerd land is ongeldig!",
      "phone-number-nan": "Telefoonnummer is geen nummer!",
      "phone-number-primary": "Telefoonnummer (primair)",
      "phone-number-too-long": "Telefoonnummer is te lang!",
      "phone-number-too-short": "Telefoonnummer is te kort!",
      "phone-numbers": "Telefoonnummer | Telefoonnummers",
      "phone-numbers-primary": "Primair",
      "plan-appointment": "Plan afspraak",
      "preview": "Voorbeeld",
      "profile": "Profiel",
      "profile-of-candidate-is-empty": "Profiel data van deze kandidaat is leeg",
      "progressing": "In behandeling",
      "propose-candidate-to-customer": "voorstelling kandidaat aan firma",
      "propose-position": "Vacature voorstellen",
      "propose-to-customer": "Voorstellen aan firma",
      "propose-to-description": "Na validatie zal een match met status <strong>'{proposeTo}'</strong> aangemaakt worden.<br>Motiveer waarom deze kandidaat geschikt is voor deze vacature.",
      "propose-to-team": "Voorstellen aan team",
      "propose-to-team-description": "Na validatie zal een match met status <b>Voorstelling kandidaat aan team</b> aangemaakt worden voor het team van de vacature.",
      "propose-to-team-description-no-position": "Na validatie zal een match met status <b>Voorstelling kandidaat aan team</b> aangemaakt worden voor het verantwoordelijk team.",
      "proposition": "voorstel",
      "proposition-created": "<b>{name}</b> met status <b>{status}</b> werd toegevoegd.",
      "publish": "Publiceren",
      "put-in": "Geef in",
      "query-to-clipboard": "Zoekopdracht gekopieerd",
      "question": "Vraag",
      "radius": "Straal",
      "reason": "Reden",
      "reference": "Referentie",
      "refresh-results": "Resultaten herladen",
      "registration": "Registratie",
      "reminder-created": "{type} <b>Terugbellen</b> met <b>{name}</b> op <b>{date}</b> werd ingepland.",
      "remove-callList": "Bellijst verwijderen",
      "remove-filters": "Verwijder zoekopdracht",
      "remove-selected-filters": "Geselecteerde filter(s) verwijderen",
      "removed-selected-filters": "{amount} geselecteerde filter(s) werden verwijderen",
      "restore-deleted-filters": "Geselecteerde filter(s) terugzetten",
      "restored-deleted-filters": "{amount} geselecteerde filter(s) werden terugzetten",
      "results": "Resultaat | Resultaten",
      "resume-type": "CV Type",
      "salutation": "Aanspreking",
      "save-call-list": "Sla bellijst op",
      "save-callList": "Sla bellijst op",
      "save-filters": "Sla zoekopdracht op",
      "saved-searches": "Opgeslagen zoekopdrachten",
      "scheduled-at": "Gepland om",
      "score": "Score",
      "select-all": "Alles selecteren",
      "select-date-and-time": "Kies een datum en tijdstip",
      "select-position": "Selecteer een vacature",
      "select-videocall-room": "Selecteer een videogesprekruimte",
      "selected": "Geselecteerd",
      "send": "Verstuur | Versturen",
      "send-appointment-via": "Afspraak sturen via",
      "send-blind-copy": "BCC versturen",
      "send-copy": "CC versturen",
      "send-NxtJourney": "Verstuur NxtForm journey",
      "send-resume-via": "Send CV via",
      "send-sms": "Verstuur SMS | Verstuur SMS'en",
      "send-videocall-invite": "Uitnodigen voor videogesprek",
      "send-whatsapp": "Verstuur WhatsApp bericht",
      "share-call-list": "Deel je bellijst",
      "share-filters": "Deel je zoekopdracht",
      "shared-with-me": "Gedeeld met mij",
      "show-less-filters": "Toon minder filters",
      "show-more": "Toon meer",
      "show-more-filters": "Toon meer filters",
      "size": "Bestandsgroote",
      "sms": "SMS",
      "sms-content": "Inhoud SMS",
      "sms-sent": "SMS is verzonden | SMS'en zijn verzonden",
      "something-went-wrong": "Er is iets fout gelopen",
      "something-went-wrong-description": "Er is iets fout gelopen tijdens het opvragen van essentiele data. Om terug te keren naar het startscherm klik op onderstaande link. Indien het probleem zich blijft voordoen, contacteer dan uw systeem administrator.",
      "specific-unit-videocall": "Specifieke unit videocall rooms",
      "spontaneous-propose-candidate-to-customer": "Spontaan voorstellen aan firma",
      "spontaneous-propose-to-customer": "Spontaan voorstellen aan firma",
      "status": "Status | Statussen",
      "subject": "Onderwerp",
      "template": "Template",
      "template-does-not-support-language": "Template ondersteunt deze taal niet.",
      "this-action-cannot-be-undone": "Deze actie kan niet ongedaan worden gemaakt.",
      "title": "Titel",
      "to": "Aan",
      "transport": "Vervoer",
      "type": "Type | Types",
      "u-have-no-access": "Geen toegang om deze pagina te zien",
      "updated-at": "Bijgewerkt op",
      "upload-date": "Upload datum",
      "url-copied": "URL gekopiëerd",
      "validate": "Valideren",
      "variables": "Variabelen",
      "verification-requested": "Er is al een verificatieverzoek naar de kandidaat verzonden",
      "verified-on": "Geverifieerd op: {dateTime}",
      "verify": "Verifieer",
      "verify-again": "Verifieer de gegevens opnieuw",
      "via": "Via",
      "videocall": "Videocall",
      "videocall-change": "Videocall aanpassen",
      "videocall-meeting": "Videocall meeting",
      "videocall-room": "Videocall-room | Videocall-rooms",
      "videocall-room-added": "Videocall room toegevoegd!",
      "videocall-room-changed": "Videocall room werd aangepast!",
      "videocall-room-removed": "Videocall room werd verwijderd!",
      "website": "Website",
      "what-do-you-want-to-send": "Wat wil je versturen?",
      "whatsapp": "WhatsApp",
      "whereby-embedded-not-available": "Whereby is niet beschikbaar voor: {type}!",
      "whereby-room": "Whereby room",
      "work-situation": "Werksituatie",
      "yes": "Ja",
      "closest-team-option": "Dichtste team",
      "kilometer": "Kilometer | km",
      "saved-search": "Opgeslagen zoekopdracht",
      "account-not-found-description": "We konden uw account niet vinden in deze module",
      "exception": "Uitzondering | Uitzonderingen",
      "limit": "Limiet | Limieten",
      "no-document-found": "Geen document gevonden",
      "pin-activity": "Vastzetten",
      "unpin-activity": "Losmaken",
      "global": "Globaal",
      "unlimited": "Ongelimiteerd",
      "publication-data": "Publicatiegegevens",
      "extra": "Extra",
      "show-result": "Toon resultaat",
      "warning": "Opgelet!",
      "nxt-jobs": "NxtJobs",
      "last-update": "Laatst geüpdatet",
      "relevance": "Relevantie",
      "take-offline-action": "Offline zetten",
      "take-offline-notification": "Offline zetten verzoek verstuurd",
      "take-offline-not-allowed": "Je hebt geen toegang om de vacature offline te zetten",
      "modify-status-action": "Status wijzigen",
      "modify-status-notification": "Status gewijzigd",
      "modify-status-not-allowed": "Je hebt geen toegang om de vacature te wijzigen",
      "recently-graduated": "Pas afgestudeerd",
      "recently-graduated-description": "Kandidaat heeft een studie succesvol afgerond in de afgelopen 3 maanden",
      "communication-preferences": "Communicatievoorkeuren",
      "update-action": "Update actie"
   },
   "matching": {
      "match": "Match | Matching",
      "select-source": "Kies een {sourceType}",
      "source-type": "Bron",
      "switch-target-source": "Bron en doel omwisselen",
      "target-type": "Doel",
      "show-type-details": "Toon {type} details"
   },
   "positions": {
      "activity": "Activiteit | Activiteiten",
      "accepted-answer": "Gewenst antwoord",
      "add-position": "Voeg vacature toe",
      "add-referral-code": "Voeg een referral code toe",
      "advertsdata": "Google vacatures",
      "application-url": "Sollicitatie-url",
      "apply": "Solliciteren",
      "apply-via": "Solliciteren via",
      "auto-repost": "Auto repost",
      "available-languages": "Beschikbare talen",
      "can-be-visible-in-app": "Weergeven in app",
      "can-take-up-to-a-minute": "Bezig met genereren van tekst! | Maak je geen zorgen, we zijn klaar voordat je het weet! | We zijn bijna klaar, dus hou vol!",
      "chatGPT": {
         "almost-done": "We zijn bijna klaar, dus hou vol!",
         "busy-generating-text": "Bezig met genereren van tekst",
         "dont-worry": "Maak je geen zorgen, we zijn klaar voordat je het weet!"
      },
      "click-to-go-to-match": "Toon match",
      "click-to-go-to-position": "Klik hier om naar de vacature te gaan",
      "comma-separated": "komma gescheiden",
      "copy-position": "Kopieer vacature",
      "create-in-nxtmatch": "Aanmaken in NxtMatch",
      "date-of-creation": "Aanmaakdatum",
      "delete-positions": "Vacature verwijderen | Vacatures verwijderen",
      "edit-position": "Pas vacature aan",
      "edit-website-status": "Publicatie op website wijzigen",
      "form-disabled": "Niet beschikbaar bij externe vacatures",
      "function-level": "Functieniveau",
      "function-title": "Functietitel",
      "generate": "Genereren",
      "generate-automatic-text": "Genereer automatische tekst",
      "generate-automatic-text-info": "Op basis van de ingegeven functietitel zal een passende vacature-tekst gegenereerd worden in de gekozen taal. Controleer deze tekst en pas deze aan zodat deze overeenstemt met de afgesproken voorwaarden.",
      "generation-error": "Kan geen tekst genereren voor de ingegeven functietitel!",
      "gross-wage": "Brutoloon",
      "internal-contact": "Intern contactpersoon | Intern contact-persoon",
      "job-type": "Jobsoort",
      "job-types": "Jobsoort",
      "journey-referral": "Journey-verwijzingscode",
      "journey-referral-code-not-found": "Journey-verwijzingscode \"nxt-match\" kan niet worden gevonden!",
      "keywords": "Trefwoorden",
      "knockout-questions": "Knock-out vraag | Knock-out vragen",
      "mail-position": "Mail vacature",
      "matches": "Matches",
      "max-10-positions": "Maximum 10 vacatures",
      "modify-status": "Ben je zeker dat je de status wil wijzigen?",
      "no-delete-position-permission": "Geen bevoegdheid om deze vacature te verwijderen",
      "no-published-position-selected": "Geen gepubliceerde vacature geselecteerd",
      "not-visible-in-app": "Vacature is niet zichtbaar in app",
      "number-of-persons-wanted": "Aantal gezochte personen",
      "online": "Online vacatures",
      "only-open-position-published": "Enkel openstaande vacatures kunnen gepubliceerd worden.",
      "open-position": "Open NxtMatch vacature",
      "people-needed": "Aantal kandidaten nog gezocht",
      "please-choose-customer": "Kies eerst een firma",
      "position": "Vacature | Vacatures",
      "position-closed": "Vacature is reeds afgesloten",
      "position-created": "Vacature is toegevoegd",
      "position-edited-and-online": "Positie is gepubliceerd, maar is gewijzigd!",
      "position-offline": "Vacature is niet gepubliceerd",
      "position-publish-failed": "Vacature {title} kan niet online worden gezet wegens fout",
      "position-published-edit-disabled": "Vacature is gepubliceerd en kan niet gewijzigd worden",
      "position-put-offline": "Vacature {title} werd offline gezet",
      "position-put-online": "Vacature {title} werd online gezet",
      "position-taken-offline": "Bij wijzigen zal de publicatie offline gehaald worden.",
      "position-updated": "Vacature werd gewijzigd",
      "processing": "Verwerken...",
      "publication": "Publicatie | Publicaties",
      "publications": {
         "no-results": "Geen publicaties gevonden!"
      },
      "put-offline": "Offline",
      "put-online": "Online",
      "referral-code-doesnt-match-with-nxt-match": "NxtMatch referral code kan niet gevonden worden of komt niet overeen met team.",
      "refresh-journey": "Vernieuw Journey",
      "required-attributes-missing": "Gelieve {attributes} in te vullen.",
      "startup-date": "Opstartdatum",
      "summary-description-info": "Deze inhoud wordt gebruikt als introtekst in de app en op vacaturesites die dit ondersteunen.",
      "title": "Vacaturetitel",
      "user-spoc": "SPOC",
      "visible-in-app": "Vacature is zichtbaar in app",
      "wage": "Loon",
      "wage-max": "Brutoloon maximum",
      "wage-min": "Brutoloon minimum",
      "wage-type": "Soort brutoloon",
      "wage-view": "Weergave brutoloon",
      "wage-view-on-website": "Weergave van brutoloon op website",
      "website-status": "Publicatie-status",
      "website_url": "Website url",
      "young-talent": "Young talent",
      "location-search-info": "Zoeken op adres van de firma. Dit kan afwijken van het tewerkstellingsadres in de vacature.",
      "publication-data": "Publicatie gegevens",
      "creation-date": "Aanmaakdatum",
      "publication-date": "Publicatie datum",
      "publication-sites": "Publicatie website | Publicatie websites",
      "nxtjob-sites": "NxtJob website | NxtJob websites",
      "remove-language-confirmation-title": "Ben je zeker dat je deze taal wil verwijderen?",
      "translate-source-badge": "Bron",
      "set-as-source": "Stel {language} in als brontaal",
      "set-as-source-info": "{language} wordt de nieuwe bron voor vertalingen",
      "translate-from-source": "Vertaal vanuit {source} naar {target}",
      "translate-from-source-info": "Overschrijft alle {target} inhoud",
      "translate-source-to-all": "Vertaal bron naar alle talen",
      "translated-language": "{language} werd automatisch vertaald",
      "translate-overwrite-title": "Vertaal vanuit {source}",
      "translate-overwrite-message": "Bestaande inhoud wordt overschreven door de automatische vertaling.",
      "translation-error": "Vertalen is mislukt. Probeer het later opnieuw.",
      "switch-source-warning": "Door de brontaal te wijzigen kan bestaande inhoud overschreven worden bij het vertalen.",
      "remove-language": "Verwijder {language}",
      "remove-language-info": "Alle inhoud voor {language} wordt gewist",
      "remove-language-confirmation-message": "Ben je zeker dat je deze taal wil verwijderen. Deze actie kan niet ongedaan gemaakt worden!",
      "hours-per-week": "Uren per week",
      "visible-in-nxt-job": "Weergeven in NxtJob",
      "position-publication": {},
      "external-publication": {
         "failed-to-load": "Recruitment technologies kon niet worden ingeladen",
         "external-publication": "Externe publicatie"
      },
      "recruit-anywhere": {
         "recruit-anywhere": "RecruitAnywhere"
      },
      "internal-publication": {
         "internal-publication": "Interne publicatie",
         "show-in-app": "Weergeven in app",
         "show-in-nxt-job": "Weergeven in NxtJob",
         "nxt-job-board": "NxtJob bord | NxtJob borden"
      },
      "tile-image": "Vacature afbeelding",
      "position_does_not_belong_to_default_team": "Vacature behoort niet tot huidig team"
   },
   "reporting": {
      "reporting": "Rapportering"
   },
   "settings": {
      "add-automatic-message": "Automatisch bericht toevoegen",
      "add-target-group": "Voeg doelgroep toe",
      "application-settings": "Applicatie instellingen",
      "applied-default-filters": "Toegepaste standaardfilters voor {name}",
      "applied-target-group-filters": "Toegepaste doelgroepen voor {name}",
       "automatic-message-delete": "Automatisch bericht verwijderen?",
       "automatic-message-deactivated-at": "Automatisch gedeactiveerd op {date}",
       "automatic-message-deactivation-inactive_journey": "De gekoppelde journey is inactief",
       "automatic-message-deactivation-limit_reached": "De berichtenlimiet is bereikt",
       "automatic-messages": "Automatisch bericht | \nAutomatische berichten",
      "available-filters": "Beschikbare filters",
      "available-target-groups": "Beschikbare doelgroepen",
      "data": "Data",
      "default-filters": "Standaardfilters",
      "developer": "Developer",
      "filter-on-priority": "Filter op prioiteit",
      "has-custom-settings": "Bevat afwijkende instellingen",
      "is-mandatory": "Verplicht toe te passen?",
      "mandrill-template": "Mandril-sjabloon",
      "name-target-group": "Naam doelgroep",
      "no-filters-selected": "Er zijn nog geen standaardfilters toegevoegd. Klik één of meerdere beschikbare filters in de lijst aan om deze toe te voegen.",
      "no-target-group-filters-selected": "Er zijn nog geen doelgroepen toegevoegd. Klik één of meerdere beschikbare doelgroepen in de lijst aan om deze toe te voegen.",
      "no-target-groups-for-target-type": "Er zijn nog geen doelgroepen toegevoegd voor dit doeltype.",
      "priority": "Prioriteit | Prioriteiten",
      "push-default-filters-to-teams": "Deze cluster bevat één of meerdere teams die afwijkende standaardfilters bevatten. {click} om de clustersettings in deze teams toe te passen.",
      "push-target-group-filters-to-teams": "Deze cluster bevat één of meerdere teams die afwijkende doelgroepen bevatten. {click} om de clustersettings in deze teams toe te passen.",
      "remove-from-list": "Verwijder uit lijst",
      "reset-team-default-filter-settings": "Dit team bevat afwijkende standaardfilters volgens de bovenliggende cluster. {click} om de standaardfilters van de cluster terug over te nemen.",
      "reset-team-target-group-filter-settings": "Dit team bevat afwijkende doelgroepen volgens de bovenliggende cluster. {click} om de doelgroepen van de cluster terug over te nemen.",
      "saved-cluster-settings": "Cluster instellingen opgeslagen",
      "saved-team-settings": "Team instellingen opgeslagen",
      "settings": "Instelling | Instellingen",
      "settings-for": "Instellingen voor {name}",
      "target-group": "Doelgroep | Doelgroepen",
      "target-group-filter-edited": "Doelgroep is gewijzigd",
      "target-group-filter-saved": "Doelgroep is aangemaakt",
      "target-type": "Doeltype",
      "teams-without-cluster": "Teams zonder teamgroep",
      "unlock-team-default-filter-settings": "De standaardfilters van de bovenliggende cluster worden toegepast. {click} om afwijkende standaardfilters voor dit team te activeren.",
      "unlock-team-settings": "De instelling van de bovenstaande cluster zijn toegepast. {click} om afwijkende instellingen te activeren voor dit team.",
      "unlock-team-target-group-filter-settings": "De doelgroepen van de bovenliggende cluster worden toegepast. {click} om afwijkende doelgroepen voor dit team te activeren.",
      "zoom": "Inzoomen",
      "incoming-messages": "Inkomende berichten",
      "responsible-team-for-incoming-messages": "Verantwoordelijk team voor berichten van onbekende nummers",
      "automatic-message-limit": "Automatische berichten limiet",
      "automatic-message-has-limit": "Heeft een limiet",
      "max-communications-per-user": "Uitgaande communicatie limieten per week",
      "max-sms": "SMS limiet",
      "max-whatsapp": "Whatsapp limiet",
      "max-email": "Email limiet",
      "communication-exception-must-have-limits": "Uitzondering moet een ingesteld limiet hebben!",
      "communication-exception-must-have-limits-description": "Vul een van de limieten, sms, Whatsapp of email in om deze te kunnen opslaan.",
      "amount-messages-sent": "{amount} berichten verstuurd",
      "empty-user-limit": "Gelieve minstens een limiet in te stellen of het geselecteerde item te verwijderen.",
      "font": "Lettertype",
      "position-card-color": "Achtergrondkleur vacaturetegel",
      "text-color": "Tekstkleur vacaturetegel",
      "example": "Voorbeeld",
      "job-board-url": "Url",
      "job-board-name": "Naam pagina",
      "show-details": "Toon details",
      "hide-details": "Verberg details",
      "cache-settings": "Lokale gegevens",
      "interface-scale": "Interface grootte",
      "intro-text": "Introtekst",
      "header-background-color": "Achtergrondkleur header",
      "header-font-color": "Tekstkleur header",
      "header-image": "Afbeelding header",
      "logo-image": "Logo",
      "vdab": "VDAB",
      "notification-email": "Notificatie emailadres voor verwijderingsaanvragen",
      "merger": "Kandidaat merger",
      "last-updated": "Laatst geüpdatet",
      "initial-candidate": "Initiële kandidaat",
      "duplicate-candidate": "Duplicate kandidaat",
      "merge": "Mergen",
      "only-deleted-searches": "Toon enkel gewiste zoekopdrachten"
   },
   "tasks": {
      "assign-user": "Gebruiker toewijzen aan taak",
      "click-to-go-to-task": "Ga naar task",
      "remove-assigned-user": "Toegewezen gebruiker verwijderen"
   },
   "teams": {
      "employer": "Werkgever | Werkgevers",
      "no-team-email": "Dit team heeft geen e-mail!",
      "no-teams-selected": "Nog geen team(s) geselecteerd",
      "team": "Team | Teams",
      "team-address": "Team-adres",
      "team-name": "Teamnaam"
   },
   "user-info": {
      "internal-job-function": "Functie",
      "log-out": "Afmelden",
      "user-settings": "Gebruikersinstellingen",
      "voip": "VoIP"
   },
   "users": {
      "no-users-selected": "Nog geen gebruiker(s) geselecteerd",
      "user": "Gebruiker | Gebruikers"
   },
   "error": {
      "user_no_country_set": "Gebruiker zijn team heeft geen land!",
      "user_no_country_set_message": "Gelieve een administrator te contacteren!"
   },
   "errors": {
      "error": "Error | Errors",
      "account-not-found": "Dit account is niet gekend."
   }
}
